import PropTypes from 'prop-types'
import React from 'react'
import styles from './icon-link.styl'

const IconLink = ({ icon, children, ...props }) => (
  <button className={styles.button} type="button" {...props}>
    <i className={`ico ico--${icon} ${styles.buttonIcon}`} />
    <span className={styles.buttonText}>
      {children}
    </span>
  </button>
)

IconLink.propTypes = {
  icon: PropTypes.string.isRequired,
  children: PropTypes.any
}

export default IconLink
